/**
 * Given an array of a known type and a value that may be undefined, this function
 * will `.push` the new item to the array if it is not undefined.
 */
export function maybePushToArray<T>(array: T[], item: T | undefined): void {
  if (item !== undefined) {
    array.push(item);
  }
}
